(function () {
  'use strict';

  class CornerFitBeforeAfter extends HTMLElement {
    connectedCallback() {
      this.range = this.querySelector('input[type="range"]');
      if (!this.range) return;
      this.onInput = () => {
        this.style.setProperty('--cf-split', `${this.range.value}%`);
        this.range.setAttribute('aria-valuetext', `${this.range.value}% after image`);
      };
      this.range.addEventListener('input', this.onInput);
      this.onInput();
    }

    disconnectedCallback() {
      this.range?.removeEventListener('input', this.onInput);
    }
  }

  class CornerFitScrollSlider extends HTMLElement {
    constructor() {
      super();
      this.onPrevious = () => this.scroll(-1);
      this.onNext = () => this.scroll(1);
      this.updateControls = this.updateControls.bind(this);
    }

    connectedCallback() {
      this.track = this.querySelector('[data-cf-slider-track]');
      this.previous = this.querySelector('[data-cf-slider-previous]');
      this.next = this.querySelector('[data-cf-slider-next]');
      if (!this.track) return;
      this.previous?.addEventListener('click', this.onPrevious);
      this.next?.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.updateControls, { passive: true });
      this.resizeObserver = new ResizeObserver(this.updateControls);
      this.resizeObserver.observe(this.track);
      this.updateControls();
    }

    disconnectedCallback() {
      this.previous?.removeEventListener('click', this.onPrevious);
      this.next?.removeEventListener('click', this.onNext);
      this.track?.removeEventListener('scroll', this.updateControls);
      this.resizeObserver?.disconnect();
    }

    scroll(direction) {
      const slide = this.track.querySelector('.cf-slider__slide');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const amount = (slide?.getBoundingClientRect().width || this.track.clientWidth) + gap;
      this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    updateControls() {
      if (!this.track) return;
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth - 2);
      if (this.previous) this.previous.disabled = this.track.scrollLeft <= 2;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max;
    }
  }

  if (!customElements.get('cf-before-after')) {
    customElements.define('cf-before-after', CornerFitBeforeAfter);
  }
  if (!customElements.get('cf-scroll-slider')) {
    customElements.define('cf-scroll-slider', CornerFitScrollSlider);
  }
})();
